<template>
  <div class="radio-group">
    <div class="btn-group-item ban" v-if="fieldForm.enable_na">
      <input
        type="radio"
        class="btn-check"
        :id="`not_applicable_${fieldForm.id}`"
        :name="`field_${fieldForm.id}`"
        v-model="fieldValue.value"
        value="NOT_APPLICABLE"
        :disabled="disabled"
      />
      <label
        class="btn btn-outline-primary"
        :for="`not_applicable_${fieldForm.id}`"
        @click="setNA"
      >
        N/A
      </label>
    </div>
    <div class="btn-group-item check">
      <input
        type="radio"
        class="btn-check"
        :id="`good_${fieldForm.id}`"
        :name="`field_${fieldForm.id}`"
        v-model="fieldValue.value"
        value="GOOD"
        :disabled="disabled"
      />
      <label
        class="btn btn-outline-primary"
        :for="`good_${fieldForm.id}`"
        @click="
          () => {
            showActionModal = true;
          }
        "
      >
        <i class="far fa-check-circle"></i>
      </label>
    </div>
    <div class="btn-group-item check triangle">
      <input
        type="radio"
        class="btn-check"
        :id="`warning_${fieldForm.id}`"
        :name="`field_${fieldForm.id}`"
        v-model="fieldValue.value"
        value="WARNING"
        :disabled="disabled"
      />
      <label
        class="btn btn-outline-primary"
        :for="`warning_${fieldForm.id}`"
        @click="
          () => {
            if (disabled) {
              if (fieldValue === 'WARNING') {
                showActionModal = true;
              }
            } else {
              showActionModal = true;
            }
          }
        "
      >
        <i class="far fa-exclamation-triangle"></i>
      </label>
    </div>
    <div class="btn-group-item times">
      <input
        type="radio"
        class="btn-check"
        :id="`bad_${fieldForm.id}`"
        :name="`field_${fieldForm.id}`"
        v-model="fieldValue.value"
        value="BAD"
        :disabled="disabled"
      />
      <label
        class="btn btn-outline-primary"
        :for="`bad_${fieldForm.id}`"
        @click="
          () => {
            if (disabled) {
              if (fieldValue === 'BAD') {
                showActionModal = true;
              }
            } else {
              showActionModal = true;
            }
          }
        "
      >
        <i class="far fa-times-circle"></i>
      </label>
    </div>
    <modal
      :show.sync="showActionModal"
      modal-classes="battery-status max-w-full w-[500px]"
    >
      <template slot="header">
        <h5 class="modal-title" id="inspection-message">
          <i class="far fa-battery-bolt"></i>
          {{ $t("INSPECTIONS.BATTERY_CHARGE") }}
        </h5>
      </template>
      <div
        class="d-flex justify-content-center"
        v-if="
          fieldForm.field_type ===
          INSPECTION_FORM_FIELD_TYPE_BATTERY_STATE_WIDGET
        "
      >
        <div class="max-w-full w-[150px]">
          <base-input
            v-model="fieldValue.percent"
            :disabled="disabled"
            :placeholder="$t('INSPECTIONS.BATTERY')"
            append-icon="%"
            input-classes="border-right-0 p-2"
            input-group-classes="text-black border-2 purge-append-border input-group-text-p-2"
            min="0"
            max="100"
            class="input-groupe-text-parent"
            type="number"
          >
            <template #append><span class="px-2 text-black">%</span></template>
          </base-input>
        </div>
      </div>
      <div v-else class="battery-status-wrapper">
        <base-input v-model="fieldValue.charge" :disabled="disabled">
        </base-input>

        <div class="form-group-separator" :disabled="disabled">/</div>

        <base-input v-model="fieldValue.total_charge" :disabled="disabled">
        </base-input>

        <base-input
          class="units"
          :label="$t('INSPECTIONS.UNIT')"
          :placeholder="$t('INSPECTIONS.UNIT')"
          :disabled="disabled"
        >
          <el-select
            v-model="fieldValue.unit"
            :placeholder="$t('INSPECTIONS.UNIT')"
            :disabled="disabled"
          >
            <el-option class="" value="AMPS">
              {{ $t("INSPECTIONS.AMPS") }}
            </el-option>
            <el-option class="" value="VOLTS">
              {{ $t("INSPECTIONS.VOLTS") }}
            </el-option>
          </el-select>
        </base-input>
      </div>
      <template slot="footer">
        <base-button
          v-if="disabled"
          type="secondary"
          class="btn close"
          @click="showActionModal = false"
        >
          {{ $t("COMMON.CLOSE") }}
        </base-button>

        <base-button
          v-if="!disabled"
          type="primary"
          class="btn save"
          @click="saveValue"
        >
          {{ $t("COMMON.SUBMIT") }}
        </base-button>
      </template>
    </modal>
  </div>
</template>

<script>
import { uniqueId } from "lodash";
import { Button, Select, Option } from "element-ui";
import {
  INSPECTION_FORM_FIELD_TYPE_BATTERY_STATE_WIDGET,
  INSPECTION_FORM_FIELD_TYPE_GAS_BATTERY_STATE_WIDGET,
} from "@/constants/inspectionForms";
import { INSPECTION_ACTION_NO_ACTION } from "@/constants/inspections";

export default {
  name: "battery-state-field-widget",

  components: {
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: ["fieldForm", "defaultValue", "disabled"],

  data() {
    const refKey = uniqueId([]);
    const fieldValue = { ...this.defaultValue };

    return {
      fieldValue,
      showActionModal: false,
      refKey: refKey,
      INSPECTION_FORM_FIELD_TYPE_BATTERY_STATE_WIDGET,
      INSPECTION_FORM_FIELD_TYPE_GAS_BATTERY_STATE_WIDGET,
    };
  },

  computed: {},

  created() {},

  methods: {
    saveValue() {
      this.$emit("change", { ...this.fieldValue });
      this.showActionModal = false;
    },

    setNA(action, comment) {
      this.$emit("change", {
        ...this.fieldValue,
        value: "NOT_APPLICABLE",
      });
      // this.$emit("actionChanged", INSPECTION_ACTION_NO_ACTION, null);
    },
  },

  mounted() {},

  watch: {
    defaultValue() {
      this.fieldValue = { ...this.defaultValue };
    },
    defaultActionValue() {
      this.actionValue = this.defaultActionValue;
    },
  },
};
</script>
<style lang="scss">
.clear-input-number-arrows {
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    margin: 0 !important;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield !important;
  }
}
.input-group-text-p-2 {
  .input-group-text {
    padding: 0.2rem !important;
  }
}
.text-black {
  color: #000 !important;
}
.input-groupe-text-parent {
  .form-group {
    .input-group-text {
      border-radius: 0 8px 8px 0;
    }
    .form-control {
      border-radius: 8px 0 0 8px !important;
    }
  }
}
.max-w-full {
  max-width: 100%;
}
.w-\[500px\] {
  width: 500px;
}
.w-\[150px\] {
  width: 150px;
}
</style>
